import { Injectable } from '@angular/core';
import { AResourceService } from './a-resource.service';
import { EmployeeModel } from '../../models/resources/employee.model';

@Injectable({
  providedIn: 'root',
})
export class EmployeeService extends AResourceService<EmployeeModel> {
  constructor() {
    super('/vitabene-employees', true);
  }
}
